import { Form, Formik, useFormikContext } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import {
  addSoapNotes,
  getSoapNote,
  patientNotesGetAction,
} from "../../actions/patientAction";
import ConfirmDialog from "../../components/ConfirmDialog";
import FormikControl from "../../components/WraapperComponent/FormikControl";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";

const SoapNote = ({
  patientId,
  setCanshowpopup,
  formRef,
  note,
  noteId,
  hideFormAction,
}) => {
  const dispatch = useDispatch();
  const [internalNote, setNote] = useState([]);
  const formikRef = useRef(null);
  const initialValues = {
    subjective: internalNote?.[0] ?? "",
    objective: internalNote?.[1] ?? "",
    assessment: internalNote?.[2] ?? "",
    plan: internalNote?.[3] ?? "",
  };

  const validationSchema = Yup.object({
    subjective: Yup.string().nullable().required("Required"),
    objective: Yup.string().nullable().required("Required"),
    assessment: Yup.string().nullable().required("Required"),
    plan: Yup.string().nullable().required("Required"),
  });

  const handleOnBlur = () => {
    if (noteId > 0) {
      formRef.current.click();
    } else {
      if (formikRef.current.isValid) {
        setCanshowpopup(true);
      }
    }
  };

  useEffect(() => {
    setNote(note?.split("||"));
  }, []);

  const onSubmit = (values) => {
    setCanshowpopup(false);
    let noteIdValue = noteId === 0 ? "" : noteId;
    let actionName = note?.length > 0 ? "editSoapNotes" : "addSoapNotes";
    dispatch(
      addSoapNotes(
        actionName,
        patientId,
        noteIdValue,
        Object.values(values).join("||"),
        () => {
          dispatch(patientNotesGetAction("getPatientNotes", patientId));
        }
      )
    );
    hideFormAction();
  };
  return (
    <div>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        innerRef={formikRef}
      >
        {({ errors, touched }) => {
          return (
            <Form>
              <div className="row">
                <div className="col-sm-12">
                  <FormikControl
                    control="textarea"
                    label="Subjective Symptoms: Onset / Location / Frequency / Aggravating Factors"
                    name="subjective"
                    rows="4"
                    placeholder=""
                    hasError={errors.subjective && touched.subjective}
                    onBlur={handleOnBlur}
                  />
                </div>
                <div className="col-sm-12">
                  <FormikControl
                    control="textarea"
                    label="Objective Findings: Visual / Palpable / Test Results"
                    name="objective"
                    rows="4"
                    placeholder=""
                    hasError={errors.objective && touched.objective}
                    onBlur={handleOnBlur}
                  />
                </div>
                <div className="col-sm-12">
                  <FormikControl
                    control="textarea"
                    label="Assessment Goals: Long Term / Short Term"
                    name="assessment"
                    rows="4"
                    placeholder=""
                    hasError={errors.assessment && touched.assessment}
                    onBlur={handleOnBlur}
                  />
                </div>
                <div className="col-sm-12">
                  <FormikControl
                    control="textarea"
                    label="Plan of treatment: Future Treatment / Frequency / Self-Care"
                    name="plan"
                    rows="4"
                    placeholder=""
                    hasError={errors.plan && touched.plan}
                    onBlur={handleOnBlur}
                  />
                </div>
              </div>
              <div className="button-section d-flex justify-content-end mr-1 mb-2">
                <button style={{ opacity: 0 }} ref={formRef} type="submit" />
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};
export default SoapNote;
